import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { rgba } from "polished";

import { CandlestickChart, ZoneChart } from "../../Icons/Trade/ChartTypeTabs";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 53px;
  margin: 0 auto;
`;

const Tab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  padding: 0;
  background-color: ${({ active }) =>
    active ? "#3B9478" : rgba("#919191", 0.4)};
  color: ${({ active }) => (active ? "#FFFFFF" : rgba("#919191", 0.7))};
  border: none;
  border-radius: ${({ left }) => (left ? "4px 0 0 4px" : "0 4px 4px 0")};
`;

const ChartTypeTabs = props => (
  <Wrapper>
    <Tab
      left={true}
      active={props.chartType === "candlestick"}
      onClick={() => {
        props.dispatch({
          type: "UPDATE_SETTINGS",
          payload: { chartType: "candlestick" }
        });
      }}
    >
      <CandlestickChart />
    </Tab>
    <Tab
      left={false}
      active={props.chartType === "line"}
      onClick={() => {
        props.dispatch({
          type: "UPDATE_SETTINGS",
          payload: { chartType: "line" }
        });
      }}
    >
      <ZoneChart />
    </Tab>
  </Wrapper>
);

function mapStateToProps(state) {
  return {
    chartType: state.settings.chartType
  };
}

export default connect(mapStateToProps)(ChartTypeTabs);



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Toolbar/ChartTypeTabs.js